interface BasicBadgeProps {
  icon: React.ReactNode;
  value: number;
}

export default function BasicBadge({ icon, value }: BasicBadgeProps) {
  return (
    <div className="transition-all duration-300 ease-out font-sans font-bold text-sm flex items-center gap-1 to-white text-brand-black dark:from-brand-black dark:to-white dark:text-brand-black focus:ring-brand-black dark:focus:ring-white rounded-full">
      <span>{icon}</span>
      <span>{value}</span>
    </div>
  );
}
